import { useEffect, useRef, useState } from "react";
import api, { errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { Upload, Trash2, ImageIcon } from "lucide-react";

export function ItemImagePanel({ itemId, t }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const load = async () => {
    try {
      const res = await api.get(`/items/${itemId}/image`, { responseType: "blob" });
      setUrl(URL.createObjectURL(res.data));
    } catch { setUrl(null); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [itemId]);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try {
      await api.post(`/items/${itemId}/image`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(t("common.saved"));
      await load();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const remove = async () => {
    try { await api.delete(`/items/${itemId}/image`); setUrl(null); toast.success(t("common.saved")); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="col-span-2 border-t pt-3 space-y-2" data-testid="item-image-section">
      <Label className="text-[10px] font-bold uppercase tracking-widest flex items-center gap-1"><ImageIcon size={12} /> {t("it.image")}</Label>
      <div className="flex gap-3 items-start">
        <div className="w-28 h-28 border bg-muted flex items-center justify-center overflow-hidden" data-testid="item-image-preview">
          {url ? <img src={url} alt="producto" className="w-full h-full object-cover" /> : <ImageIcon size={20} className="text-muted-foreground" />}
        </div>
        <div className="space-y-2">
          <input ref={fileRef} type="file" accept=".png,.jpg,.jpeg,.webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="item-image-input" />
          <Button size="sm" variant="outline" className="rounded-none text-xs h-7" disabled={busy} onClick={() => fileRef.current?.click()} data-testid="item-image-upload-btn">
            <Upload size={12} className="mr-1" /> {busy ? "…" : t("it.imageUpload")}
          </Button>
          {url && (
            <Button size="sm" variant="ghost" className="rounded-none text-xs h-7 text-destructive block" onClick={remove} data-testid="item-image-remove-btn">
              <Trash2 size={12} className="mr-1 inline" /> {t("it.imageRemove")}
            </Button>
          )}
          <p className="text-[9px] text-muted-foreground max-w-xs">{t("it.imageHint")}</p>
        </div>
      </div>
    </div>
  );
}
